import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Clock, Sparkles } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const handlePurchase = () => {
    // Track AddToCart event before redirecting
    trackAddToCart();
    // Small delay to ensure tracking fires before redirect
    setTimeout(() => {
      window.location.href = 'https://pay.hotmart.com/U104232902M';
    }, 300);
  };
  return <div className="py-16 px-4 sm:px-6 bg-white" data-id="element-136">
      <div className="max-w-4xl mx-auto" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8" data-id="element-138">
          <Button size="lg" className="bg-amber-600 hover:bg-amber-700 text-white text-xl px-12 py-6 shadow-xl hover:shadow-2xl transition-all" onClick={handlePurchase} data-id="element-139">
            Descargar Ahora →
          </Button>
        </motion.div>

        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 mb-12" data-id="element-140">
          <div className="flex items-center text-amber-700 font-semibold text-sm sm:text-base" data-id="element-141">
            <Clock className="w-5 h-5 mr-2" data-id="element-142" />
            <span data-id="element-143">Solo 200 copias disponibles</span>
          </div>
          <div className="flex items-center text-amber-700 font-semibold text-sm sm:text-base" data-id="element-144">
            <Sparkles className="w-5 h-5 mr-2" data-id="element-145" />
            <span data-id="element-146">Solo por tiempo limitado</span>
          </div>
        </div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-cream-50 to-white border-2 border-amber-200 rounded-2xl p-8 sm:p-12 shadow-lg max-w-2xl mx-auto" data-id="element-147">
          <div className="text-center mb-6" data-id="element-148">
            <div className="inline-block bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wide mb-4" data-id="element-149">
              Oferta de Lanzamiento
            </div>
            <div className="flex items-center justify-center gap-4 mb-4" data-id="element-150">
              <span className="text-3xl sm:text-4xl text-gray-400 line-through font-semibold" data-id="element-151">
                $47,99
              </span>
              <span className="text-5xl sm:text-6xl md:text-7xl font-bold text-amber-600" data-id="element-152">
                $7,99
              </span>
            </div>
            <div className="inline-block bg-green-100 text-green-800 px-6 py-2 rounded-full font-bold text-lg" data-id="element-153">
              Ahorras $40 (83% de descuento)
            </div>
          </div>

          <div className="border-t border-amber-200 pt-6 mt-6" data-id="element-154">
            <p className="text-center text-navy-600 text-sm mb-4" data-id="element-155">
              Acceso digital inmediato • Sin suscripciones • Tuyo para siempre
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}